export { default } from "./IOSInstallationBanner-component";
